const guidesPage = {
  "guides.title": "Guides",
  "guides.passing_basics.title": "How To Play",
  "guides.passing_basics.description": "Basic instructions on how to play.",
  "guides.decision_making.title": "Decision Making",
  "guides.decision_making.description": "Learn how decision making works.",
  "guides.scan_rate.title": "Scan Rate",
  "guides.scan_rate.description": "Explains the mechanics of Scan Rate.",
  "guides.scan_timing.title": "Scan Timing",
  "guides.scan_timing.description": "Explains the mechanics of Scan Timing.",
  "guides.awareness.title": "Awareness",
  "guides.awareness.description": "Learn how awareness tests work.",
  "guides.critical_scan.title": "Critical Scan",
  "guides.critical_scan.description": "Learn how critical scan works.",
};

const howToPlay = {
  "how-to-play.heading": "How To Play",
  "how-to-play.description.1": "Use the markers to locate the ball and opponent goal. Remember! You are always on the BLUE team.",
  "how-to-play.description.2":
    "In each scenario you will receive the ball. A grid appears when you are in possession of the ball. You must look at the ball to receive it!",
  "how-to-play.description.3.1": "Find a pass!",
  "how-to-play.description.3.2": "Point to aim",
  "how-to-play.description.4": "Look at your hands to check your controls",
};

const scanning = {
  "scanning.heading": "Scanning",
  "scanning.description.1": "Scanning is all about seeing the situation around you. To scan, look away from the ball and then to it.",
  "scanning.description.2.1": "You will be scored on your Scan Rate.",
  "scanning.description.2.2": "Scan as often as possible, remember you must look at the ball to receive it.",
};

const scanTiming = {
  "scan-timing.heading": "Scan Timing",
  "scan-timing.description.1": "Scan Timing is about looking at the ball and looking away from it at the correct moments.",
  "scan-timing.description.2": "Look at the ball when it is being kicked",
  "scan-timing.description.3": "Look at the ball when it is being received",
  "scan-timing.description.4": "Scan when the ball is in flight",
};

const awareness = {
  "awareness.heading": "Awareness",
  "awareness.description.1": "During a test some players will be hidden.",
  "awareness.description.2": "Choose the correct team for each player.",
  "awareness.description.3": "Once you have answered you will see your results.",
  "awareness.description.4": "You only have limited time to answer, so be quick!",
};

export const guides = {
  ...guidesPage,
  ...howToPlay,
  ...scanning,
  ...scanTiming,
  ...awareness,
};
